import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { lowHeightScreens, mediumScreens } from 'components/common/fontElements';

export const SidePadding = '33px';
export const VerticlePadding = '12px';

export const Table = styled.table`
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  table-layout: fixed;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
`;

export const Row = styled.tr`
  cursor: ${(props) => props.hoverPointer && 'pointer'};
  border-bottom: 1px solid ${colors.lightGray12};
  background-color: ${colors.baseBackground};
  transition: 0.3s;
  &:hover {
    background-color: ${colors.lightGray30};
  }

  td:first-child {
    padding: ${VerticlePadding} 10px ${VerticlePadding} ${SidePadding};
  }
`;

export const HeaderRow = styled.tr`
  border-bottom: 1px solid ${colors.lightGray12};
  background-color: ${colors.baseBackground};
  transition: 0.3s;
  th:first-child {
    padding: ${VerticlePadding} 10px ${VerticlePadding} ${SidePadding};
  }
`;

export const TableData = styled.td`
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => (props.dark ? colors.gulfBlue : colors.slateGray)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: ${VerticlePadding} 10px;
  &:hover {
    cursor: ${(props) => props.dark && 'pointer'};
    text-decoration: ${(props) => props.dark && 'underline'};
  }
`;

export const TableHeader = styled.th`
  background-color: ${colors.baseBackground};
  font-stretch: condensed;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
  color: ${colors.darkGray9};
  font-size: 10px;
  padding: ${VerticlePadding} 10px;
`;
